import actionTypes from './action-types';
import initialState from './initial-state';

export default (state = initialState, action) => {
    if (!action || !action.type) return state;
    switch (action.type) {
        case actionTypes.RECEIVE_CATEGORY_LIST:
            return {
                ...state,
                list: action.payload,
                isFetching: false,
                error: null
            };
        case actionTypes.RECEIVE_TOP_LEVEL_CATEGORIES:
            return {
                ...state,
                topLevelCategories: action.payload,
                isFetching: false,
                error: null
            };
        case actionTypes.REQUEST_CATEGORY_LIST:
            return { ...state, isFetching: true, error: null };
        case actionTypes.HANDLE_CATEGORY_LIST_ERROR:
            return { ...state, isFetching: false, error: action.payload };
        case actionTypes.HANDLE_TOP_LEVEL_CATEGORIES_ERROR:
            return { ...state, isFetching: false, error: action.payload };
        default:
            return state;
    }
};
